

/*
window.addEventListener("dx_init", function(event){ 
    //alert("dx_init"); 
    //dx_navigations_init(); 
    //alert("dx_init_complete"); 
      
});
*/

if(window.parent==window){
    window.addEventListener("load", function(){
        dx_navigations_init();
    });    
}    

//setInterval(dx_navigations_init, 1000);
/*
window.addEventListener("DOMContentLoaded", function(){
        //checkPlaceholders()
        setTimeout(checkPlaceholders, 1); 
});   
*/ 

/*
window.addEventListener("load", function(){
   
   
    
    const isEditor=window.parent.document.getElementsByTagName("body")[0].classList.contains("wp-admin");
    //console.log(isEditor);
    if(isEditor){
       setTimeout(checkPlaceholders, 100); 
    } else {
         dx_navigations_init();  
    }
   
     
});
*/
/*
function checkPlaceholders(){
    // search for placeholders in patterns
    var placeholders = document.getElementsByClassName("components-placeholder");  
    if(placeholders.length>0){ 
        // waiting for placeholder     
        setTimeout(()=>{
            checkPlaceholders();
            //alert("check"); 
        }, 100);
    } else {
        dx_navigations_init();  
        //alert("ok"); 
       
    }  
}
    */

window.addEventListener("dx_navigation_init", function(event){ 
    //console.log(event.detail.block);
    dx_navigation_init(event.detail.block);
});

window.addEventListener("dx_navigation_title", function(event){ 
    //console.log(event.detail.block);
    dx_navigation_title(event.detail.block);
});
  

function dx_navigations_init(){ 
    /*
    Dx = window.parent.Dx; 
    if(Dx == undefined){
        Dx = window.Dx; 
    }
        */
    //alert(Dx);
   
    
    var blocks = document.getElementsByClassName("wp-block-dx-navigation"); 
    for(var i = 0; i<blocks.length; i++){         
        dx_navigation_init(blocks[i]);               
    }   
}    

/*
function dx_navigation_init2(event){
    alert("foo");
} 
    */   

function dx_navigation_init(block){
    //var Dx = window.parent.Dx; 
    /*
    if(Dx == undefined){
        Dx = window.Dx; 
    }
        */
    //console.log("init single");
   
    if(block.getAttribute("data-init")=="1"){
       return;
    }
    block.setAttribute("data-init", "1");
    

    dx_navigation_title(block);


    //if(block.getAttribute("data-init")=="1") return;
    //block.setAttribute("data-init", "1");   

   

    block.setAttribute("data-open", 0);  
      
    block.getElementsByClassName("wp-block-dx-navigation-items")[0].style.opacity=1;
    
    
    let head =  block.getElementsByClassName("wp-block-dx-navigation-head")[0];
    head.onclick = function(event){   
        let block = event.currentTarget.parentNode.parentNode;
        let open = block.getAttribute("data-open");
        let body = block.getElementsByClassName("wp-block-dx-navigation-body")[0];
        let items = block.getElementsByClassName("wp-block-dx-navigation-items")[0];
        let lines = block.getElementsByClassName("wp-block-dx-navigation-head-icon-line");
        if(open == 1){
            open = 0;
            
            body.style.transition="height 0.3s";
            body.style.height=items.offsetHeight+"px";
            //block.style.marginBottom=-items.offsetHeight+"px";
            setTimeout(()=>{
                body.style.overflow="hidden";
                body.style.transition="height 0.3s";
                body.style.height="0px";
                //block.style.marginBottom="0px";
            }, 1);
            lines[0].style.transform="translate(-18px, -3.5px) rotate(0deg)";
            lines[1].style.transform="translate(-18px, 3.5px) rotate(0deg)";
        } else {
            open = 1;
            //body.style.height="auto";
            body.style.transition="height 0.3s";
            body.style.height=items.offsetHeight+"px";
            //block.style.marginBottom=-items.offsetHeight+"px";
            setTimeout(()=>{
                body.style.height="auto";
                body.style.overflow="visible";
                //body.style.backgroundColor="green";
                //body.style.display="none"; //ios fix?
            }, 300);
            lines[0].style.transform="translate(-18px, 0px) rotate(45deg)";
            lines[1].style.transform="translate(-18px, 0px) rotate(-45deg)";
        }
        block.setAttribute("data-open", open);
    }

    const items= block.getElementsByClassName("wp-block-dx-navigation-item"); 
    for(let i = 0; i<items.length; i++){   
        let item =  items[i].getElementsByTagName("a")[0];       
        let itemURL = item.getAttribute("data-url");
        items[i].onclick=function(event){
            //alert(event.currentTarget.getElementsByTagName("a")[0].getAttribute("target"));
            if(event.currentTarget.getElementsByTagName("a")[0].getAttribute("target") == "_self"){
                //document.body.style.opacity=0;
                window.document.getElementsByTagName( 'html' )[0].classList.remove("js-ready");
            }
            //
        }
        if(itemURL != null && itemURL != "" && itemURL == Dx.page.url){           
            //items[i].classList.add("wp-block-dx-navigation-item-active");
            item.classList.add("active");
            //items[i].getElementsByTagName("a")[0].style.color="red";
        } else {
            //items[i].classList.remove("wp-block-dx-navigation-item-active");
            item.classList.remove("active");
        } 
        //console.log(itemURL);
        //console.log(Dx.pag.title);
       
            console.log(itemURL);
            console.log(item.innerHTML.toLowerCase());
            
            if(Dx.page.url.split("/").indexOf(item.innerHTML.toLowerCase())!=-1){
                item.classList.add("sub-active");
            } else {
                item.classList.remove("sub-active");
            } 
            
      
    }

    new ResizeObserver((event)=>{     
        dx_navigation_onResize(block);
    }).observe(block);

    // content observer ()
    var observer = new MutationObserver((mutationList) => {
        dx_navigation_onResize(block);         
    }).observe(block, {
        childList:     true,
        characterData: true,
        subtree: true
    });
}

function dx_navigation_title(block){ 
    let headText=block.getElementsByClassName("wp-block-dx-navigation-head-text")[0];
    if(headText.getAttribute("data-title")=="site"){
        headText.innerHTML = Dx.site.title;
        block.getElementsByClassName("wp-block-dx-navigation-title")[0].innerHTML=Dx.site.title;
        if(block.getElementsByClassName("wp-block-dx-navigation-title-linked")[0]!=undefined){
            block.getElementsByClassName("wp-block-dx-navigation-title-linked")[0].href=Dx.url.home;
        }
        
    } else {
        headText.innerHTML = Dx.page.title;
    } 

    
    dx_navigation_onResize(block); 

}    

function dx_navigation_onResize(block){   
   
    let fullWidth = block.offsetWidth;   
    
    //let fullWidth = block.getElementsByClassName("wp-block-dx-navigation-items")[0].offsetWidth;
    let gap = parseInt(getComputedStyle(block.getElementsByClassName("wp-block-dx-navigation-innerblocks")[0]).gap);   
    let itemsWidth = 0;    
    const items= block.getElementsByClassName("wp-block-dx-navigation-item"); 
    if(items.length>0){
        itemsWidth -= gap;
    }
    for(let i = 0; i<items.length; i++){         
        itemsWidth += items[i].getElementsByClassName("wp-block-dx-navigation-item-inner")[0].offsetWidth + gap; 
    }
    //console.log(itemsWidth+"/"+fullWidth);
    let wrapper = block.getElementsByClassName("wp-block-dx-navigation-wrapper")[0];
    if(itemsWidth>=fullWidth - 2){       
        wrapper.classList.add("wp-block-dx-navigation-collapsed");
        wrapper.classList.remove("wp-block-dx-navigation-regular");
    } else {       
        wrapper.classList.remove("wp-block-dx-navigation-collapsed");
        wrapper.classList.add("wp-block-dx-navigation-regular");
    }
}

/*
function dx_navigations_update(){
    var blocks = document.getElementsByClassName("wp-block-dx-navigation"); 
    for(var i = 0; i<blocks.length; i++){         
        dx_navigation_update(blocks[i]);               
    }  
}   

function dx_navigation_update(block){
    
}
*/
  
